// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportSubscribe.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = require('react');

  var connect = require('share/enhancers/Izenda.Connect');
  var SubscriptionGrid = require('modules/Subscription/Izenda.SubscriptionGrid');
  var ReportSubscriptionConstants = require('logic/data/Izenda.ReportSubscriptionConstants');
  var actions = require('./Izenda.ReportSubscribeActions');
  var ReportDesignerConstants = require('logic/data/Izenda.ReportDesignerConstants');

  var ReportSubscribe = React.createClass({
    PropTypes:{
      reportId: React.PropTypes.string.isRequired,
      reportType: React.PropTypes.string.isRequired,
      subscribedInstancesStore: React.PropTypes.object.isRequired,
      onClose: React.PropTypes.func
    },

    componentWillMount: function () {
      this.props.setType(true);
    },

    componentDidMount: function () {
      var reportListMode = !!this.props.onClose;
      this.props.loadData(reportListMode);
    },

    componentWillUnmount: function () {
      var subscribedInstancesStore = this.props.subscribedInstancesStore;

      subscribedInstancesStore.cleanSubscription.call(subscribedInstancesStore);
    },

    /**
     * render subscribe component
     * @return {Object} subscribe component
     */
    render: function () {
      var props = this.props;
      var reportListMode = !!this.props.onClose;
      var subscribedInstancesStore = props.subscribedInstancesStore;

      return (
        <SubscriptionGrid reportState={ReportDesignerConstants.REPORT_STATE.SAVED}
                          store={props.subscribedInstancesStore}
                          pageConstants={ReportSubscriptionConstants}
                          containerWidth={props.width}
                          onSavePopupDesigner={props.onSaveSubscription}
                          onSave={props.onSave}
                          onClose={props.onClose}
                          isDashboardMode={reportListMode}
                          doesSaveToDB={reportListMode} />
      );
    }
  });

  module.exports = connect(actions)(ReportSubscribe);
} ();



// WEBPACK FOOTER //
// ./ui/modules/Reports/ReportSubscribe/Izenda.ReportSubscribe.jsx